import { render, staticRenderFns } from "./SensorBatteryIndicator.vue?vue&type=template&id=b340f544&"
import script from "./SensorBatteryIndicator.vue?vue&type=script&lang=ts&"
export * from "./SensorBatteryIndicator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports